// extracted by mini-css-extract-plugin
export default {"element":"story-tile_element__fF0dn","imageWrap":"story-tile_imageWrap__LvFU4","show":"story-tile_show__8HkCL","info":"story-tile_info__Vre91"};